<app-ace-table
  #table
  [loading]="loading"
  [columnMode]="ColumnMode.flex"
  [externalPaging]="true"
  [count]="count"
  [rows]="rows"
  [rowClass]="allowToOpenTickets ? 'clickable' : undefined"
  [columns]="tableColumns"
  [limit]="pageSize"
  (activate)="ticketRowSelected($event)"
  (page)="setPage($event)">

  <ng-template #headerTemplate let-column="column">
    <b>{{column.name | messageTranslate}}</b>
  </ng-template>

  <ng-template #cellTemplate let-value="value">
    {{value}}
  </ng-template>
</app-ace-table>
